
import { Vue, Component, Prop } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'

@Component({
  name: 'IconCtrl',
  components: {
    Icon
  }
})
export default class IconCtrl extends Vue {
  @Prop() name!: string
  @Prop() size!: string
  @Prop() color!: string
}
